module.exports = __webpack_public_path__ + "static/img/function_yard.0c785c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/function_yard.png
// module id = JW1m
// module chunks = 37